import React from "react"
import MeetingContactForm from "../../blocks/meeting-contact-form/MeetingContactForm.js"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing-3"
const ContactFormSection = ({
  title,
  subTitle,
  legalMention,
  contextForm,
  buttonText,
  confirmationText
}) => {
  return (
    <ModalRoutingContext.Consumer>
    {({ modal, closeTo }) => (
    <MeetingContactForm
      title={title}
      subTitle={subTitle}
      legalMention={legalMention}
      contextForm={contextForm}
      hasMeeting={false}
      closeTo={closeTo}
      buttonText={buttonText}
      confirmationText={confirmationText}
    />
    )}
    </ModalRoutingContext.Consumer>
  )
}

export const name = "ContactFormSection"

export const init = (componentData, pageContext) => {
  return (
    <ContactFormSection
      key={componentData.id}
      leftContentBuilder={componentData.leftContentBuilder}
      title={componentData.label}
      subTitle={componentData.subTitle}
      legalMention={componentData.legalMention}
      contextForm={pageContext?.itemData?.attributes?.contextForm}
      buttonText={componentData.buttonText}
      confirmationText={componentData.confirmationText}
    />
  )
}

export default ContactFormSection
